var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { Ng2BootstrapModule } from 'ngx-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ContentLoggedOutComponent } from './content-loggedout.component';
import { FooterLoggedOutComponent } from './footer-loggedout.component';
import { ConnexionComponent } from '../connexion/connexion.component';
import { Auth0Module } from '../modules/auth/auth.module';
import { contentLoggedoutRouting } from './content-loggedout.routing';
export function httpFactory(http) {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json?t=' + process.env.VERSION);
}
var ContentLoggedOutModule = (function () {
    function ContentLoggedOutModule() {
    }
    ContentLoggedOutModule = __decorate([
        NgModule({
            imports: [
                BrowserModule,
                FormsModule,
                Ng2BootstrapModule,
                contentLoggedoutRouting,
                HttpClientModule,
                Auth0Module,
                TranslateModule.forRoot({
                    loader: {
                        provide: TranslateLoader,
                        useFactory: httpFactory,
                        deps: [HttpClient]
                    }
                }),
            ],
            declarations: [
                ContentLoggedOutComponent,
                FooterLoggedOutComponent,
                ConnexionComponent
            ],
            providers: [
                Title
            ],
            bootstrap: [ContentLoggedOutComponent]
        })
    ], ContentLoggedOutModule);
    return ContentLoggedOutModule;
}());
export { ContentLoggedOutModule };
//# sourceMappingURL=content-loggedout.module.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/components/content-loggedout.module.js
// module id = 812
// module chunks = 0